import { Box, IconButton, Typography, useTheme, Button } from "@mui/material";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ColorModeContext, tokens } from "../../theme";
import InputBase from "@mui/material/InputBase";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import SearchIcon from "@mui/icons-material/Search";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import { useAuth } from "../../context/AuthContext";
import { getRoleCapabilities } from "../../config/permissions";

const Topbar = ({ setIsSidebar }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = useContext(ColorModeContext);
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const caps = getRoleCapabilities(user?.role);

  return (
    <Box display="flex" justifyContent="space-between" p={2} alignItems="center">
      <Box display="flex" alignItems="center" gap={1}>
        <IconButton onClick={() => setIsSidebar?.((s) => !s)}>
          <MenuOutlinedIcon />
        </IconButton>
        <Box
          display="flex"
          backgroundColor={colors.primary[400]}
          borderRadius="3px"
        >
          <InputBase sx={{ ml: 2, flex: 1 }} placeholder="Search" />
          <IconButton type="button" sx={{ p: 1 }}>
            <SearchIcon />
          </IconButton>
        </Box>
      </Box>

      <Box display="flex" alignItems="center" gap={1}>
        {user ? (
          <Typography variant="body2" color={colors.grey[200]} sx={{ mr: 1 }}>
            {user.name || user.email} · {user.role}
          </Typography>
        ) : null}
        <Button
          color="secondary"
          variant="outlined"
          size="small"
          onClick={() => {
            logout();
            navigate("/", { replace: true });
          }}
        >
          Logout
        </Button>
        <IconButton onClick={colorMode.toggleColorMode}>
          {theme.palette.mode === "dark" ? (
            <DarkModeOutlinedIcon />
          ) : (
            <LightModeOutlinedIcon />
          )}
        </IconButton>
        <IconButton>
          <NotificationsOutlinedIcon />
        </IconButton>
        {caps.canUseSettingsUi ? (
          <IconButton aria-label="settings" onClick={() => navigate("/settings")}>
            <SettingsOutlinedIcon />
          </IconButton>
        ) : null}
      </Box>
    </Box>
  );
};

export default Topbar;
